import React, { useState } from 'react';
import { Button, TextField, Dialog, DialogContent, DialogTitle } from '@mui/material';
import validator from 'validator';
import './ContactUs.style.scss';
import {useDispatch} from "react-redux";
import {sendContactUsAsync} from "../../stores/account/account.thunks";
import {FormattedMessage, useIntl} from "react-intl";

const ContactUs = ({id, title, subTitle, open, onClose, onCancel, onOk, options, data}) => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({ name: false, email: false, message: false });
    const [isValid, setIsValid] = useState(false);
    const intl = useIntl();

    const validateForm = () => {
        const nameValid = name.trim() !== '';
        const emailValid = validator.isEmail(email);
        const messageValid = message.trim() !== '';

        setErrors({
            name: !nameValid,
            email: !emailValid,
            message: !messageValid,
        });

        setIsValid(nameValid && emailValid && messageValid);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isValid) {
            dispatch(sendContactUsAsync({ name, email, message }))
            onClose();
        }
    };

    return (
        <Dialog className={"ContactUs"} open={open} onClose={onClose} >
            <DialogTitle className="contactUsTitle"><FormattedMessage id={"popUp.contactUs.title"}/></DialogTitle>
            <DialogContent>
                <div className={"closeButton"} onClick={onClose}>X</div>
                <form className="contactUsForm" onSubmit={handleSubmit}>
                    <div className="contactUsInput">
                        <label><FormattedMessage id={"popUp.contactUs.name"}/></label>
                        <input
                            type="text"
                            value={name}
                            placeholder={intl.formatMessage({ id: 'popUp.contactUs.enterYourName' })}
                            onChange={(e) => setName(e.target.value)}
                            onBlur={validateForm}
                            className={errors.name ? 'error' : ''}

                        />
                        {errors.name &&
                            <span className="error"><FormattedMessage id={"popUp.contactUs.nameCannotBeEmpty"}/></span>}
                    </div>
                    <div className="contactUsInput">
                        <label><FormattedMessage id={"popUp.contactUs.email"}/></label>
                        <input
                            type="email"
                            value={email}
                            placeholder={intl.formatMessage({ id: 'popUp.contactUs.enterYourEmail' })}
                            onChange={(e) => setEmail(e.target.value)}
                            onBlur={validateForm}
                            className={errors.email ? 'error' : ''}
                        />
                        {errors.email && <span className="error"><FormattedMessage
                            id={"popUp.contactUs.emailCannotBeEmpty"}/></span>}
                    </div>
                    <div className="contactUsInput" >
                        <label><FormattedMessage id={"popUp.contactUs.message"}/></label>
                        <textarea
                            rows={5}
                            value={message}
                            placeholder={intl.formatMessage({ id: 'popUp.contactUs.message' })}
                            onChange={(e) => setMessage(e.target.value)}
                            onBlur={validateForm}
                            className={errors.message ? 'error' : ''}
                        />
                        {errors.message && <span className="error"><FormattedMessage
                            id={"popUp.contactUs.messageCannotBeEmpty"}/></span>}
                    </div>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={!isValid}
                        className={"contactUsButton" + (isValid ? ' valid' : '')}
                    >
                        <FormattedMessage id={"popUp.contactUs.sendMessage"}/>
                    </Button>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default ContactUs;
